module.exports = __webpack_public_path__ + "img/melani-method-nlae-bundle.8b4a7c59.jpeg";